import { Accordion } from "./Accordion";
import { SettingsIcon, MailIcon } from "lucide-react";
import { OBJECIONES } from "../data/content";
export function ObjecionesSoporte() {
  return <section className="px-5 pt-12" data-id="element-161" data-mp="2xvc41d28fihq">
      <h2 className="text-center text-2xl font-black text-blue-950" data-id="element-162" data-mp="2j177iq4i7y40">
        Preguntas frecuentes
      </h2>

      <div className="mt-6 space-y-3" data-id="element-163" data-mp="2nyh9t6czs499">
        {OBJECIONES.map(o => <Accordion key={o.q} title={o.q} data-id="element-164" data-mp="2a7khlgmz9p2q">
            <p className="text-sm leading-relaxed text-gray-700" data-id="element-165" data-mp="2a6j1uyv0oeeo">{o.a}</p>
          </Accordion>)}
      </div>

      {/* Soporte */}
      <div className="mt-10 flex flex-col items-center rounded-2xl border border-blue-100 bg-white/90 p-6 text-center shadow-sm backdrop-blur" data-id="element-166" data-mp="209xw2bb6az9s">
        <div className="flex h-14 w-14 items-center justify-center rounded-full bg-blue-100 text-blue-700" data-id="element-167" data-mp="259srms5w8d16">
          <SettingsIcon size={28} data-id="element-168" data-mp="1r9ro14y8uri0" />
        </div>
        <p className="mt-3 text-sm font-bold text-blue-950" data-id="element-169" data-mp="1valbxybos6aw">Atención al cliente</p>
        <a href="mailto:EbookDreamShop@gmail.com" className="mt-1 flex items-center gap-1.5 text-sm font-semibold text-blue-700 underline" data-id="element-170" data-mp="1vco4ap0babis">
          <MailIcon size={15} data-id="element-171" data-mp="1ht7uxewrfe25" />
          EbookDreamShop@gmail.com
        </a>
      </div>
    </section>;
}